module.exports = __webpack_public_path__ + "static/media/albatross_projects_americas_logo.d312e2a2.png";